import PropTypes from "prop-types";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";

function DeleteConfirmModal({
  open,
  message,
  onCancel,
  onConfirm,
  cancelLabel = "Cancel",
  confirmLabel = "Delete",
}) {
  return (
    <Modal
      open={open}
      aria-labelledby="delete-confirm-title"
      aria-describedby="delete-confirm-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          p: "20px 24px",
          bgcolor: "background.paper",
          borderRadius: "10px",
          minWidth: 320,
        }}
      >
        <Typography id="delete-confirm-description">{message}</Typography>
        <Stack
          direction="row"
          justifyContent="center"
          spacing={2}
          sx={{ mt: "22px" }}
        >
          <Button color="error" variant="contained" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

DeleteConfirmModal.propTypes = {
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
};

DeleteConfirmModal.defaultProps = {
  cancelLabel: "Cancel",
  confirmLabel: "Delete",
  onCancel: () => {},
  onConfirm: () => {},
  open: false,
};

export default DeleteConfirmModal;
